import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoriesNav() {
  const displayCategories = categories.filter((c) => c.slug !== 'all').slice(0, 8);

  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 overflow-x-auto pb-2 flex-wrap">
          <Link
            to="/category/all"
            className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-foreground-900 text-white text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-apps-line text-xs"></i>
            全部
          </Link>
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-background-100 text-foreground-600 text-sm hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer border border-transparent hover:border-primary-200"
            >
              <i className={`${cat.icon} text-xs`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}